import React from 'react'
import Tippy from '@tippyjs/react'
import * as S from './styles'

import imgFacebook from '../../../../assets/images/defaults/facebookIcon.png'
import imgInstagram from '../../../../assets/images/defaults/instagramIcon.png'
import imgLinkedin from '../../../../assets/images/defaults/linkedinIcon.png'
import { trans } from '../../../../i18n'
import {
  TENANT_SHORT_NAME,
  TENANT_CONTACT_EMAIL,
  TENANT_SOCIAL_FACEBOOK_URL,
  TENANT_SOCIAL_INSTAGRAM_URL,
  TENANT_SOCIAL_LINKEDIN_URL
} from '../../../../constants/zingConfigInfo'
import { useAuthLayout } from '../../../../hooks/useAuthLayout'

const socialMediaImgLinks = [
  {
    image: imgFacebook,
    altText: 'Logo Facebook',
    width: 30,
    height: 30,
    href: TENANT_SOCIAL_FACEBOOK_URL,
    tooltipContent: 'Facebook'
  },
  {
    image: imgInstagram,
    altText: 'Logo Instagram',
    width: 40,
    height: 40,
    href: TENANT_SOCIAL_INSTAGRAM_URL,
    tooltipContent: 'Instagram'
  },
  {
    image: imgLinkedin,
    altText: 'Logo Linkedin',
    width: 30,
    height: 30,
    href: TENANT_SOCIAL_LINKEDIN_URL,
    tooltipContent: 'LinkedIn'
  }
]

export const HotsiteFooter = (): React.ReactElement => {
  const { logoUrlWhite } = useAuthLayout()
  
  const labels = {
    emailContact: `${trans('Contate-nos')}: ${TENANT_CONTACT_EMAIL}`,
    rightsReserved: trans('Todos os direitos reservados')
  }

  return (
    <S.FooterWrapper>
      <S.FooterLinksWrapper>
        <a className="d-flex w-full align-items-center justify-content-center mt-4">
          <img src={logoUrlWhite} width="150" height="50" loading="lazy" alt="Zing" />
        </a>
        <S.SocialList>
          {socialMediaImgLinks.map((social) => (
            <S.SocialItem key={social.href}>
              <a href={social.href} target="_blank" rel="noreferrer">
                <Tippy content={social.tooltipContent}>
                  <img src={social.image} width={social.width} height={social.height} alt={social.altText} />
                </Tippy>
              </a>
            </S.SocialItem>
          ))}
        </S.SocialList>
        <S.FooterHr />
        <S.FooterEmail>{labels.emailContact}</S.FooterEmail>
        <S.FooterCopyright>
          {`Copyright © 2022 ${TENANT_SHORT_NAME.toUpperCase()}. ${labels.rightsReserved}`}
        </S.FooterCopyright>
      </S.FooterLinksWrapper>
    </S.FooterWrapper>
  )
}
